"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = void 0;
var events_1 = require("./events");
var Events = (function () {
    function Events() {
        this.selectionChanged = new events_1.SelectionChangedEvent();
        this.documentLoaded = new events_1.DocumentLoadedEvent();
        this.documentFormatted = new events_1.DocumentFormattedEvent();
        this.documentChanged = new events_1.DocumentChangedEvent();
        this.activeSubDocumentChanged = new events_1.ActiveSubDocumentChangedEvent();
        this.gotFocus = new events_1.GotFocusEvent();
        this.lostFocus = new events_1.LostFocusEvent();
        this.hyperlinkClick = new events_1.HyperlinkClickEvent();
        this.pointerDown = new events_1.PointerDownEvent();
        this.pointerUp = new events_1.PointerUpEvent();
        this.keyDown = new events_1.KeyDownEvent();
        this.keyUp = new events_1.KeyUpEvent();
        this.calculateDocumentVariable = new events_1.CalculateDocumentVariableEvent();
        this.contentInserted = new events_1.ContentInsertedEvent();
        this.contentRemoved = new events_1.ContentRemovedEvent();
        this.characterPropertiesChanged = new events_1.CharacterPropertiesChangedEvent();
        this.paragraphPropertiesChanged = new events_1.ParagraphPropertiesChangedEvent();
        this.autoCorrect = new events_1.AutoCorrectEvent();
        this.saving = new events_1.SavingEvent();
        this.saved = new events_1.SavedEvent();
        this.customCommandExecuted = new events_1.CustomCommandExecutedEvent();
        this.pdfExporting = new events_1.PdfExportingEvent();
        this.pdfExported = new events_1.PdfExportedEvent();
        this.commandStateChanged = new events_1.CommandStateChangedEvent();
        this.calculateDocumentVariableAsync = new events_1.CalculateDocumentVariableAsyncEvent();
        this.contextMenuShowing = new events_1.ContextMenuShowingEvent();
    }
    Events.prototype.clear = function () {
        this.selectionChanged.clearHandlers();
        this.documentLoaded.clearHandlers();
        this.documentFormatted.clearHandlers();
        this.documentChanged.clearHandlers();
        this.activeSubDocumentChanged.clearHandlers();
        this.gotFocus.clearHandlers();
        this.lostFocus.clearHandlers();
        this.hyperlinkClick.clearHandlers();
        this.pointerDown.clearHandlers();
        this.pointerUp.clearHandlers();
        this.keyDown.clearHandlers();
        this.keyUp.clearHandlers();
        this.calculateDocumentVariable.clearHandlers();
        this.contentInserted.clearHandlers();
        this.contentRemoved.clearHandlers();
        this.characterPropertiesChanged.clearHandlers();
        this.paragraphPropertiesChanged.clearHandlers();
        this.autoCorrect.clearHandlers();
        this.saving.clearHandlers();
        this.saved.clearHandlers();
        this.customCommandExecuted.clearHandlers();
        this.pdfExporting.clearHandlers();
        this.pdfExported.clearHandlers();
        this.commandStateChanged.clearHandlers();
        this.contextMenuShowing.clearHandlers();
        this.calculateDocumentVariableAsync.clearHandlers();
    };
    return Events;
}());
exports.Events = Events;
